const NODE6 = {
  NAME: 'TH-DHT11',
  INPUT1: {
    NAME: 'NODE6_INPUT1_NAME',
    TYPE: 'temperatureSensor',
    ICON: 'temperature',
    PARAMETER_ID: 0x8120,
  },
  INPUT2: {
    NAME: 'NODE6_INPUT2_NAME',
    TYPE: 'humiditySensor',
    ICON: 'humidity',
    PARAMETER_ID: 0x8121,
  },
  TEMPERATURE: {
    NAME: 'NODE6_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
NODE6.DEFAULT_INSTRUCTIONS = [];

export default NODE6;